function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIqaa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1400,
    height: 2400,
    viewBox: "0 0 1400 2400",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M0 0L0 2400L618 2400L618 2399C571.606 2398.87 523.448 2373.01 487 2346.57C476.531 2338.98 467.653 2328.88 457 2321.7C445.657 2314.06 431.694 2310.01 420 2302.56C400.231 2289.97 384.038 2270.87 373.602 2250C333.048 2168.89 373.541 2057.82 466 2037.42C482.863 2033.71 499.97 2033.11 517 2035.92C534.663 2038.84 551.102 2045.4 566 2055.33C644.418 2107.63 651.261 2226.35 583 2289.91C567.555 2304.29 548.991 2314.48 529 2321C531.788 2329.75 538.631 2337.76 544.13 2345C563.851 2370.98 594.279 2391.91 628 2392L628 2400L1400 2400L1400 429L1399 429C1398.99 520.88 1321.02 599.31 1236 623.573C1192.3 636.042 1146.77 634 1102 634L1165.67 730L1295.33 924L1339.33 990L1362 1025L1317 1054.33L1229 1113.33L955 1296L804 1397L756 1429L732 1446L731 1446C701.131 1392.35 662.073 1342.11 628 1291C557.967 1185.95 487.702 1081.05 417.667 976C391.188 936.282 364.567 896.654 338.001 857L318 827C316.036 824.054 311.037 818.914 311.73 815.093C312.441 811.17 319.012 808.325 322 806.333L351 787L470 707.667C577.053 636.298 683.945 564.703 791 493.333L892 426C907.142 415.905 927.718 406.402 940 393L941 393C971.117 447.094 1010.65 497.482 1045 549L1074.33 593C1077.83 598.251 1081.83 607.672 1087.33 610.972C1092.22 613.907 1101.46 611.797 1107 612.039C1123.45 612.76 1139.58 612.08 1156 612.001C1183.04 611.87 1211.19 609.081 1237 600.485C1306.6 577.301 1375.09 513.42 1376.99 436C1378.04 392.921 1361.62 350.202 1337.66 315C1330.51 304.509 1318.9 286.492 1307 281.222C1300.72 278.441 1293.1 286.501 1286 285.829C1267.11 284.04 1245.18 275.816 1230 264.522C1219.47 256.685 1213.38 245.83 1208.28 234C1205.82 228.303 1203.87 219.932 1199.5 215.419C1194.87 210.642 1185.22 209.958 1179 208.92C1166.22 206.787 1152.33 205.375 1141 198.521C1127.68 190.464 1123.93 172.915 1109 169L1112 161L1066 130C1070.98 120.63 1079.69 122.22 1088 126.259C1103.4 133.742 1115.32 147.237 1131 154C1126.29 146.274 1100.82 137.581 1114 129C1108.09 117.607 1096.23 110.531 1084 108C1088.99 92.6902 1099.59 89.2869 1112 100.184C1122.38 109.299 1128.29 120.849 1137.19 131C1149.47 145.026 1167.18 155.462 1186 157C1185 133.669 1157.47 132.489 1142 121.076C1133.86 115.071 1131.54 105.805 1124.61 99.51C1120.23 95.5342 1111.5 93.2886 1106 91L1117 81C1111.87 72.1309 1103.42 67.8186 1095 62.5747C1091.89 60.6353 1085.33 57.7185 1084.21 53.9219C1081.62 45.1741 1097.56 48.1436 1101 49.821C1118.55 58.3733 1125.96 79.053 1146 82C1142.17 65.4517 1133.57 48.1523 1124.3 34C1120.76 28.5879 1109.5 20.1453 1108.77 14C1108.19 9.1084 1116.55 3.43359 1120 1L1091 0L1025 0L795 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eb6e03",
      stroke: "none"
    },
    d: "M1120 0C1116.29 2.82837 1107.53 8.61914 1108.04 14C1108.69 20.8318 1121.71 30.8105 1125.57 37C1131.29 46.158 1136 55.9885 1140 66C1142.02 71.0554 1143.52 78.6653 1147.42 82.5818C1152.98 88.1665 1165.68 91.9529 1173 95C1166.29 65.9917 1147.89 46.5977 1131.44 23C1126.49 15.9021 1124.85 6.79565 1120 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M1121 0C1125.52 21.8306 1142.52 36.3374 1154.65 54C1162.92 66.0447 1164.78 82.1985 1173.09 93.6211C1177.93 100.28 1187.14 102.902 1192.21 110C1195.79 115.01 1195.52 120.749 1198.32 125.826C1200.94 130.587 1207.62 134.925 1212 138C1206.71 121.739 1203.55 103.212 1193.56 89C1190.6 84.7917 1176.68 76.5757 1177.31 71.9568C1178.1 66.2319 1186.87 54.6587 1192.99 59.2568C1211.24 72.9956 1205.11 103.805 1216.87 122C1225.34 135.124 1239.55 141.428 1252 150.025C1261.76 156.766 1269.85 165.463 1276.84 175C1283.52 184.105 1289.96 194.198 1293.48 205C1295.54 211.316 1294.44 219.692 1301 223C1298.19 188.543 1271.63 163.735 1249 141C1235.39 127.326 1230.71 111.136 1223.14 94C1220.56 88.1697 1216.21 82.9963 1213.85 77.1697C1212.27 73.2468 1218.24 63.9363 1222.83 65.9214C1226.8 67.6404 1229.78 74.3804 1231.68 78C1237.9 89.8201 1240.32 103.397 1247.01 115C1256.03 130.63 1270.04 142.347 1281.56 156C1295.97 173.071 1307.63 192.91 1317.25 213C1323.95 226.975 1332.49 247.967 1317 259C1324.05 268.803 1334.61 276.567 1342.39 286C1371.92 321.822 1398.97 363.567 1399 412L1400 412L1400 0L1121 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eb6e03",
      stroke: "none"
    },
    d: "M1186 147L1185 140C1188.21 141.246 1192.97 142.36 1194.98 145.394C1197.39 149.046 1195.95 153.793 1199.43 157.099C1206.67 163.98 1218.97 166.163 1225.03 174.21C1232.71 184.413 1233.35 198.579 1238.09 210C1241.95 219.281 1250.32 227.733 1257.09 235C1264.18 242.605 1272.4 249.492 1281 255.33C1283.29 256.887 1289.39 259.648 1288.23 263.241C1286.59 268.289 1278.01 267.23 1274 266.907C1257.39 265.565 1247.53 252.827 1235 244C1243.97 274.267 1279.3 263.377 1301 273C1296.3 260.597 1282.57 252.321 1274.45 242C1262.34 226.608 1252.36 207.026 1245 189C1253.35 197.421 1260.31 203.633 1272 207C1257.94 174.419 1230.65 147.111 1201 128.598C1187.58 120.219 1171.96 115.925 1159 106.791C1151.69 101.636 1146.65 94.6482 1140.84 88C1130.09 75.6997 1120.65 62.2109 1107 52.7739C1101.61 49.0454 1093.48 45.0667 1087.02 48.4568C1081.05 51.5881 1083.68 55.5972 1088 58.6521C1095.87 64.2036 1105.12 68.0896 1111.91 75.04C1123.25 86.6409 1123.64 103.231 1134.19 114.985C1144.89 126.908 1159.66 129.223 1172.96 136.532C1177.81 139.198 1181.24 144.021 1186 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9a769",
      stroke: "none"
    },
    d: "M1296 220C1295.8 195.644 1277.2 169.389 1259 154.465C1235.76 135.403 1213.49 127.747 1207.75 95C1205.9 84.4592 1204.61 72.9265 1198.21 64C1195.79 60.6296 1191.7 55.2085 1187.04 57.801C1183.21 59.9326 1175.62 68.9883 1176.82 73.7871C1177.79 77.6643 1185.13 80.4978 1187.91 83.1736C1193.86 88.9011 1197.79 96.4062 1200.8 104C1204.78 114.044 1205.81 130.338 1212.7 138.621C1216.27 142.907 1222.55 145.563 1227 148.895C1235.13 154.986 1241.97 161.898 1248.1 170C1263.4 190.204 1270.69 210.42 1296 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eb740a",
      stroke: "none"
    },
    d: "M1312 260C1333.23 257.066 1325.24 230.253 1319.57 217C1310.18 195.041 1296.96 173.254 1281.56 155C1269.38 140.568 1253.95 128.161 1245.37 111C1239.39 99.0481 1236.81 85.5454 1229.99 74C1228.19 70.9609 1224.65 63.4272 1220.08 65.176C1216.68 66.4727 1212.66 72.3313 1213.12 76C1213.74 80.9773 1218.99 86.5037 1221.24 91C1225.93 100.374 1228.69 110.567 1233.26 120C1243.61 141.392 1264.24 153.496 1278.35 172C1290.65 188.138 1294.08 205.96 1301.7 224C1305.06 231.956 1312.2 236.912 1313.67 246C1314.46 250.844 1312.69 255.281 1312 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c65b0e",
      stroke: "none"
    },
    d: "M1134 80C1147.69 103.684 1173.19 117.609 1198 127C1195.28 105.59 1180.8 98.5056 1163 89.7561C1154.05 85.3574 1144.12 80.2151 1134 80M1106 91L1125 99C1123.63 85.3403 1114.86 75.708 1106 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eb6e03",
      stroke: "none"
    },
    d: "M1084 108C1096.72 111.611 1105.95 118.434 1114 129C1122.05 126.804 1126.79 125.828 1135 128C1128.7 116.158 1119.41 103.721 1108 96.3882C1095.96 88.6506 1086.9 95.4644 1084 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c65b0e",
      stroke: "none"
    },
    d: "M1066 130C1084.7 141.445 1101.1 156.763 1121 166.11C1142.15 176.046 1167.34 178.651 1185 195.09C1206.45 215.066 1206.21 248.733 1231 265.961C1246.02 276.401 1267.63 284.654 1286 285.911C1291.01 286.254 1308.62 282.451 1304 275L1304 274C1307.73 270.382 1309.68 265.882 1311.33 261C1323.7 224.399 1274.63 206.495 1248 196L1262.89 216L1272.94 241L1301 273C1285.58 263.631 1264.71 271.581 1249 260.779C1240.91 255.215 1237.76 247.802 1232.53 240C1221.76 223.905 1211.47 202.824 1197.82 189.13C1180.12 171.38 1150.69 166.939 1130 153.504C1115.52 144.101 1102.04 131.576 1086 124.876C1078.4 121.7 1069.19 120.849 1066 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9a769",
      stroke: "none"
    },
    d: "M1121 126.529C1116.88 127.459 1104.87 130.844 1109.38 136.83C1114.96 144.238 1125.92 148.413 1134 152.255C1151.57 160.609 1170.46 166.868 1186 178.888C1210.39 197.754 1219.8 229.766 1242 250.961C1251.47 260.007 1271.81 272.558 1285.79 266.396C1290.08 264.503 1288.88 260.431 1285.93 258.04C1272.43 247.108 1259.68 237.516 1248.44 224C1233.99 206.641 1223.09 180.312 1205 166.708C1191.46 156.532 1173.43 156.363 1159 148.127C1146.77 141.147 1136.64 122.996 1121 126.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c65b0e",
      stroke: "none"
    },
    d: "M1185 140C1186.53 154.47 1185.58 158.005 1200 164C1198.33 152.678 1196.77 143.22 1185 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eb6e03",
      stroke: "none"
    },
    d: "M1129 150C1131.81 157.087 1139.45 159.684 1146 162.691C1161.83 169.96 1177.9 179.906 1194 186C1181.66 168.845 1148.89 155.729 1129 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M1198 157C1202.1 169.38 1218.45 184.385 1231 188C1227.28 172.317 1213.13 161.82 1198 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed740a",
      stroke: "none"
    },
    d: "M1112 161L1109 169C1123.81 174.19 1127.02 191.32 1141 199.096C1158.96 209.082 1181.01 207.675 1200 215C1195.16 198.246 1170.26 204.546 1157 198.651C1144.2 192.964 1142.5 181.792 1134.1 172.394C1129.52 167.277 1118.32 163.723 1112 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M1134 172C1137.35 179.17 1141.15 187.393 1147.04 192.815C1159.46 204.24 1179.41 202.784 1195 206C1182.86 186.592 1156.07 175.26 1134 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c65b0e",
      stroke: "none"
    },
    d: "M1217 181C1220.25 188.676 1226.55 198.141 1235 200C1234 188.569 1226.18 185.833 1217 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M1244 188L1245 189L1244 188M1245 189C1246.38 193.636 1248.36 196.386 1253 198L1245 189M1231 199L1236 208L1237 208C1236.33 203.596 1235.33 200.65 1231 199M1253 206L1254 207L1253 206M1254 207L1268 233L1269 233C1267.62 222.752 1263.62 212.005 1254 207M1237 208L1238 209L1237 208M1269 234L1270 235L1269 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db6e13",
      stroke: "none"
    },
    d: "M1311 260L1304 274L1304 275L1305 280C1361 322.662 1392.09 412.169 1368.31 479C1353.92 519.414 1322.6 552.379 1287 575.308C1242.17 604.181 1195.06 610.681 1143 612.961C1107.35 614.522 1073.35 610.704 1038 618.887C942.936 640.892 873.289 735.097 855.804 828C849.568 861.133 852.978 892.772 853 926C856.638 925.53 864.558 925.372 866.968 922.262C869.398 919.125 866.753 911.586 866.282 908C864.561 894.918 864 882.184 864 869C864 813.884 887.539 756.569 923.131 715C963.834 667.462 1018.9 639.08 1081 633.17C1093.77 631.954 1106.3 634.845 1119 634.996C1154.1 635.413 1190.61 634.172 1225 626.576C1278.83 614.687 1331.32 579.491 1363.57 535C1383.26 507.845 1399.29 472.288 1398.7 438C1398.03 399.012 1377.99 364.384 1364.68 329C1361.69 321.033 1360.72 311.459 1356.74 304C1350.97 293.198 1341.3 284.088 1333.29 275C1327.4 268.324 1320.68 259.091 1311 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9a769",
      stroke: "none"
    },
    d: "M1358 307L1385.66 379L1398 435L1399 435C1400.46 401.05 1394.58 367.751 1379.25 337C1373.93 326.345 1367.92 314.046 1358 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003366",
      stroke: "none"
    },
    d: "M940 393C890.122 431.339 834.357 463.762 782 498.667C680.279 566.481 578.72 634.52 477 702.333L355 783.667L323 805C319.629 807.247 312.757 810.179 311.252 814.184C309.906 817.769 314.181 822.269 316 825L334.667 853C360.253 891.38 386.077 929.615 411.667 968C481.702 1073.05 551.968 1177.95 622 1283C658.007 1337.01 691.449 1394.55 731 1446L732 1446C787.013 1403.71 848.623 1368.7 906 1329.66C1057.12 1226.82 1210.46 1127.23 1362 1025C1358.49 1013.98 1349.06 1003.59 1342.67 994L1302.67 934C1258.41 867.618 1213.92 801.386 1169.67 735L1122.33 664C1117.01 656.021 1110.22 639.809 1101.82 635.028C1096.31 631.896 1085.2 633.971 1079 634.001C1053.31 634.125 1027.33 642.592 1004 652.579C925.366 686.234 873.26 768.396 865.17 852C862.84 876.071 865.987 900.28 869 924C863.854 924.107 851.751 929.122 847.51 926.188C844.342 923.996 844.246 918.395 843.925 915C843.066 905.917 842 897.148 842 888C842 849.136 847.239 810.296 861.8 774C897.82 684.214 988.701 614.027 1087 612L1055 563L989.333 465L957.333 417L940 393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#46464b",
      stroke: "none"
    },
    d: "M1080 612L1080 613L1087 613L1080 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e4c42",
      stroke: "none"
    },
    d: "M1068 613L1068 614L1072 614L1068 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#574a45",
      stroke: "none"
    },
    d: "M1061 614L1061 615L1064 615L1061 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#514947",
      stroke: "none"
    },
    d: "M1054 615L1054 616L1057 616L1054 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70513b",
      stroke: "none"
    },
    d: "M1049 616L1049 617L1052 617L1049 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c503d",
      stroke: "none"
    },
    d: "M1044.67 617.333L1045.33 617.667L1044.67 617.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#835634",
      stroke: "none"
    },
    d: "M1028.67 621.333L1029.33 621.667L1028.67 621.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a503d",
      stroke: "none"
    },
    d: "M1078 633L1078 634L1087 634L1078 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e434e",
      stroke: "none"
    },
    d: "M1087 633L1087 634L1101 634L1087 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f513c",
      stroke: "none"
    },
    d: "M1068 634L1068 635L1072 635L1068 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8a5831",
      stroke: "none"
    },
    d: "M1061 635L1061 636L1064 636L1061 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#835634",
      stroke: "none"
    },
    d: "M1055 636L1055 637L1058 637L1055 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#765339",
      stroke: "none"
    },
    d: "M1050 637L1050 638L1053 638L1050 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#554c49",
      stroke: "none"
    },
    d: "M982.667 639.333L983.333 639.667L982.667 639.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9a769",
      stroke: "none"
    },
    d: "M976 645C971.113 644.291 965.919 649.387 962 652C950.332 659.779 939.6 668.419 929 677.576C878.142 721.512 853.013 781.808 844.424 847C841.763 867.203 843.073 887.756 843.961 908C844.126 911.766 842.984 927.426 849.075 927.248C855.914 927.049 852.02 911.961 852.001 908C851.896 886.243 850.854 865.703 853.87 844C865.082 763.308 909.707 692.656 976 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a88168",
      stroke: "none"
    },
    d: "M854.333 794.667L854.667 795.333L854.333 794.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c7c68",
      stroke: "none"
    },
    d: "M852.333 801.667L852.667 802.333L852.333 801.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a27f68",
      stroke: "none"
    },
    d: "M851.333 805.667L851.667 806.333L851.333 805.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#977968",
      stroke: "none"
    },
    d: "M850.333 809.667L850.667 810.333L850.333 809.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#544946",
      stroke: "none"
    },
    d: "M872.333 811.667L872.667 812.333L872.333 811.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e6e67",
      stroke: "none"
    },
    d: "M849.333 813.667L849.667 814.333L849.333 813.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#514947",
      stroke: "none"
    },
    d: "M871.333 815.667L871.667 816.333L871.333 815.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#887268",
      stroke: "none"
    },
    d: "M848.333 818.667L848.667 819.333L848.333 818.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f4c42",
      stroke: "none"
    },
    d: "M870.333 819.667L870.667 820.333L870.333 819.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b6c67",
      stroke: "none"
    },
    d: "M847.333 823.667L847.667 824.333L847.333 823.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#765339",
      stroke: "none"
    },
    d: "M869.333 823.667L869.667 824.333L869.333 823.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595c67",
      stroke: "none"
    },
    d: "M846.333 828.667L846.667 829.333L846.333 828.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b5437",
      stroke: "none"
    },
    d: "M868.333 828.667L868.667 829.333L868.333 828.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f513c",
      stroke: "none"
    },
    d: "M867 834L867 837L868 837L867 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686467",
      stroke: "none"
    },
    d: "M845 835L845 838L846 838L845 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#45464b",
      stroke: "none"
    },
    d: "M866 840L866 844L867 844L866 840z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b7468",
      stroke: "none"
    },
    d: "M844 842L844 847L845 847L844 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6667",
      stroke: "none"
    },
    d: "M843 851L843 858L844 858L843 851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965b2d",
      stroke: "none"
    },
    d: "M864 857L864 864L865 864L864 857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f3f54",
      stroke: "none"
    },
    d: "M864 864L864 888L865 888L864 864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bc8a68",
      stroke: "none"
    },
    d: "M842 866L842 897L843 897L842 866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b5d2b",
      stroke: "none"
    },
    d: "M864 888L864 893L865 893L864 888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a6c67",
      stroke: "none"
    },
    d: "M842 897L842 903L843 903L842 897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d4c42",
      stroke: "none"
    },
    d: "M865 897L865 902L866 902L865 897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b18568",
      stroke: "none"
    },
    d: "M843 903L843 912L844 912L843 903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#514947",
      stroke: "none"
    },
    d: "M867 914L867 917L868 917L867 914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a7b68",
      stroke: "none"
    },
    d: "M844 918L844 921L845 921L844 918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e4c42",
      stroke: "none"
    },
    d: "M868 920L866 923L866 924C868.649 923.432 869.355 922.412 868 920z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#765339",
      stroke: "none"
    },
    d: "M861.667 924.333L862.333 924.667L861.667 924.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70513b",
      stroke: "none"
    },
    d: "M856 925L856 926L859 926L856 925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00457e",
      stroke: "none"
    },
    d: "M450.985 1170.76C442.842 1172.82 433.947 1181.04 427 1185.67L377 1219L208 1331.67C189.28 1344.15 170.71 1356.84 152 1369.33C147.449 1372.37 134.896 1378.25 133.881 1384.04C132.987 1389.14 140.964 1397.92 143.667 1402C154.076 1417.69 164.556 1433.33 175 1449C216.146 1510.72 257.523 1572.28 298.667 1634C310.664 1652 322.332 1670.27 334.72 1688C337.536 1692.03 343.094 1704.25 349.015 1703.03C356.807 1701.43 365.459 1693.03 372 1688.67C389.301 1677.13 406.811 1665.88 424 1654.19C480.329 1615.89 537.308 1578.46 594 1540.67C612.386 1528.41 630.68 1516.02 649 1503.67C653.491 1500.64 666.091 1495.1 666.404 1488.96C666.695 1483.25 658.718 1474.59 655.667 1470L624.333 1423C583.855 1362.28 543.142 1301.71 502.667 1241C490.446 1222.67 478.477 1204.14 465.975 1186C463.016 1181.71 457.34 1169.15 450.985 1170.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#014780",
      stroke: "none"
    },
    d: "M433 1237L434 1242L427 1242L428 1248L417 1248L417 1253L398 1251L398 1250L402 1243L390 1243L391 1248L384 1249L386 1254L374 1254L375 1259L368 1259L369 1265L358 1265L358 1270L352 1270L353 1276L334 1277L335 1280L319.09 1278.22L298 1282L298 1287L292 1287L293 1293L281 1293L282 1298C275.08 1297.86 264.672 1294.59 265 1305L258 1305L259 1308C253.21 1308.02 247.858 1308.97 249 1316L242 1316L243 1319C236.634 1319.02 232.778 1320.04 232 1327L225 1327L226 1330C216.926 1330.03 215.354 1333.45 216 1342L210 1342L211 1347L199 1347L200 1353L193 1353L195 1358L176 1359L177 1362C170.634 1362.02 166.778 1363.04 166 1370L161 1370L164 1375L162 1377L148 1385L154 1394C153.392 1399.24 156.44 1409.01 161 1412C161.124 1417.21 167.665 1425.16 172 1428C172.096 1432.75 174.972 1442.24 179 1445C179.124 1450.21 185.665 1458.16 190 1461C190.283 1472.96 207.772 1482.22 210 1495L242.515 1544.58L274.54 1591.71L293.327 1616.28L320.11 1660L334 1677L342 1689C342.312 1695.78 347.365 1693.63 352 1692L355 1695C355 1692.41 359.684 1691.84 362.167 1690.5C369.667 1686.44 376.642 1681.49 384 1677.5C395.122 1671.48 404.502 1662.25 414.167 1654.33C421.784 1648.09 433.182 1645.09 441 1638.83C448.851 1632.55 459.843 1620.87 470 1619L469 1616C475.198 1614.44 479.069 1612.94 480 1606C489.238 1605.73 497.162 1602.15 496 1592L502 1592L501 1588L513 1587L512 1581L518 1581L517 1577L528 1570L528 1567L534 1567C535.852 1561.46 539.264 1559.31 545 1559L545 1556L562 1554L561 1548L567 1548L567 1543L579 1543L578 1537L584 1537L583 1533L595 1532L594 1526L600 1526L603 1516L599 1515C601.742 1510.91 603.414 1507.95 602 1503L608 1503L608 1498L620 1498L619 1492L625 1492L628 1482L624 1481C626.742 1476.91 628.414 1473.95 627 1469L633 1469L636 1459L632 1458L636 1452L624 1452L628 1447L624 1446L628 1440L616 1440L620 1437L620 1436L616 1435L620 1429L608 1429L612 1424L608 1423L612 1417L600 1417L608 1408L602 1408L604 1400L597 1399L597 1398L599 1397L594 1396L593 1384L586 1384L589 1380L583 1380C584.944 1373.36 583.423 1368.24 576 1368L578 1365L572 1364L572 1352L559 1351L563 1343C555.006 1343 550.279 1343.68 554 1335L548 1335L552 1327L540 1327L544 1319L517 1315L519 1312L513 1311L515 1306L502 1306L505 1299L500 1298L504 1290C496.006 1290 491.279 1290.68 495 1282L489 1282L493 1274L481 1274L485 1266L478 1266L478 1265L483 1258L471 1258L471 1263L451 1261L451 1260L456 1253L443 1253L446 1246L441 1245L445 1237L433 1237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#044c87",
      stroke: "none"
    },
    d: "M384 1318L385 1324L373 1324L374 1329L351.09 1326.22L330 1330L330 1335L313 1333.13L286 1336L287 1341L280 1341L281 1347L270 1347L270 1352L264 1352L265 1357L253 1357L254 1363C247.505 1362.87 236.686 1359.11 237 1369L230 1369L231 1372C225.21 1372.02 219.858 1372.97 221 1380L189 1385C187.56 1390.12 184.281 1393.18 179 1394L180 1396L173 1396L177 1402L179 1412C174.773 1414.83 177.423 1419.65 181 1422C181.114 1427.11 184.519 1436.25 189 1439C189.089 1444.07 191.66 1454.03 196 1457C196.184 1464.79 209.8 1485.31 217 1489C217.879 1494.24 223.37 1501.27 228 1504L235.219 1518.04L247.216 1540L261 1562C268.701 1570.38 275.131 1579.84 278 1591L287.937 1604.83L316.139 1648.26L329 1663L328 1665L341 1673L340 1676L350 1681L349 1679L350 1679L354 1683L371 1680L371 1676L388 1667C389.446 1662.36 394.619 1660.95 399 1660L401 1656L400 1654L403 1654L408 1646L430 1634L429 1632L446 1623L445 1621L463 1612L462 1610L466 1610C469.116 1599.42 485.171 1587.62 495 1584L494 1581C500.471 1580.93 504.095 1578.75 505 1572C516.904 1571.24 521.25 1566.5 520 1555L531 1548L531 1547L525 1547L533 1541L532 1538L536 1537C535.444 1530.67 540.775 1530.06 546 1530L545 1524L551 1524L554 1514L550 1513C552.742 1508.91 554.414 1505.95 553 1501L559 1501L559 1496L571 1496L570 1490L576 1490L579 1480L575 1479L579 1473L570 1473L572 1470L570 1470L575 1464L572 1464L572 1463L574 1462L574 1461L570 1455L576 1455L579 1445L575 1444L579 1438L570 1438L570 1437L572 1436L575 1430L572 1430L572 1429L574 1426L570 1421L577 1421L573 1415L572 1412L572 1411L574 1408L560 1406C559.479 1401.77 553.802 1401.17 550 1401C553.315 1394.24 550.026 1390.08 543 1390L544 1386L539 1386L539 1374L526 1373L530 1365L518 1365L522 1357L469 1346L470 1344L464 1344L465 1339L453 1339L454 1344L434 1342L438 1334L426 1334L430 1326L384 1318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a5491",
      stroke: "none"
    },
    d: "M307 1419L308 1421L253 1427L253 1432L247 1432L247 1435L236 1435L236 1438L210 1443L219 1464C219.351 1479.74 235.626 1497.3 243.204 1510.05C259.061 1536.73 271.477 1565.38 287.04 1592.17C292.299 1601.22 300.281 1607.96 305.495 1616.83C310.798 1625.85 326.652 1633.43 335.424 1639.6C339.52 1642.48 342.8 1646.18 348 1645L347 1643L369 1634L378 1626L377 1624L381 1623L380 1621C386.704 1618.35 389.617 1615.46 390 1608L394 1608L399 1599L397 1599L398 1594L401 1590C404.569 1589.24 404.11 1587.06 403 1584L415 1580L414 1576L420 1576L419 1572L437 1570L436 1566C440.58 1565.85 443.534 1564.91 444 1560L448 1558L447 1555L453 1555L456 1551L457 1546L455 1546L460 1540L457 1540L457 1539L462 1535L461 1531L472 1524L471 1518L475 1518L474 1515L482 1509L476 1509L484 1503L483 1500L487 1499L489 1493L490 1489L488 1489L493 1483L490 1483L490 1482L491 1477L495 1477L494 1471C497.688 1469.92 497.635 1467.49 497 1464L500 1460L495 1460L497 1455L484 1455L485 1450L480 1451L480 1448L475 1448L475 1444L440 1439L441 1437L430 1435L431 1433L403 1430L405 1425L377 1425L378 1423L361.985 1424.66L307 1419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#02559a",
      stroke: "none"
    },
    d: "M171.91 1572.25C168.2 1571.98 163.929 1576.09 161 1577.95C152.582 1583.29 144.295 1588.8 136 1594.33C103.35 1616.1 70.1657 1637.24 38 1659.72C28.7583 1666.18 19.3472 1672.37 10 1678.67C7.18578 1680.57 1.80067 1683.19 1.59568 1687.09C1.20584 1694.51 13.3155 1706.97 17.3333 1713L64 1783L101.333 1839C104.342 1843.5 110.258 1856.13 116.04 1857C119.792 1857.57 124.115 1853.59 127 1851.67L151 1835.67L250 1769.67C259.348 1763.43 268.848 1757.38 278 1750.86C280.602 1749.01 286.32 1746.39 286.758 1742.82C287.628 1735.73 275.136 1722.7 271.333 1717L224.667 1647C211.965 1627.95 199.225 1608.93 186.344 1590C183.425 1585.71 177.674 1572.67 171.91 1572.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d5fa1",
      stroke: "none"
    },
    d: "M99 1653L100 1659L93 1659L94 1661L83 1661L83 1664C77.2381 1664.12 68.9368 1663.62 67 1670C58.1895 1670.08 53.8472 1675.81 46.7145 1680.2C41.0058 1683.71 34.1181 1685.35 28 1688L28 1698L26 1698C30.2583 1707.75 31.956 1718.29 37.0486 1728C46.8992 1746.77 60.2872 1763.85 71.1782 1782C76.3104 1790.55 84.0577 1808.78 94 1812C95.2558 1825.94 113.925 1842.81 128.575 1836.15C150.734 1826.07 168.06 1804.79 188.745 1791.72C194.004 1788.39 197.82 1783.85 204 1782L204 1778C208.293 1774.32 222.096 1766.06 219 1760L230 1749L234 1740L238 1729L234 1728C236.24 1725.35 237.963 1718.35 235 1716L235 1715L235 1714L238 1709L235 1708C241.23 1696.42 223.941 1697.42 223 1691L219 1691L219 1690L221 1689L217 1688C216.8 1684.16 214.502 1684.12 211 1684L212 1681C208.174 1680.41 205.55 1679.05 205 1675C199.555 1674.15 194.679 1669.56 194 1664C188.882 1664 184.973 1664.36 183 1659L171 1657L173 1654C147.58 1647.86 124.446 1652.46 99 1653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1868a9",
      stroke: "none"
    },
    d: "M79 1692L79 1695C71.4375 1695 57.4632 1697.17 51.3333 1701.5C48.1983 1703.71 45.9372 1708.49 42 1709C50.3222 1743.46 69.7235 1775.42 90.287 1803.83C97.3293 1813.56 107.036 1830.02 121.09 1830.8C129.675 1831.28 136.644 1818.38 144 1815L144 1811C155.052 1809.3 162.873 1797.25 169.039 1789.04C175.108 1780.96 182.727 1772.81 190 1766L199 1754L200 1748L203 1748L202 1746L209 1732L206 1732L206 1731L210 1726C209.558 1723.35 212.535 1718.85 210 1716C207.313 1712.98 201.112 1712.56 198 1711C195.889 1709.94 193.882 1706.46 192 1705C188.023 1701.91 178.665 1704.34 180 1699L154 1696L151 1691L123 1687.18L79 1692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e7bb8",
      stroke: "none"
    },
    d: "M58 1732C65.5774 1750.47 73.5704 1768.42 82.7415 1786.09C88.7336 1797.64 96.0869 1811.04 109.174 1816.31C118.286 1819.98 127.797 1809.47 133.139 1802.98C147.787 1785.17 169.007 1763.54 176 1741C171.308 1740.39 169.636 1737.31 165.624 1735.58C154.757 1730.9 140.806 1727.47 129 1726.18C111.343 1724.25 91.5241 1725.71 74 1728.14C68.3621 1728.93 63.9378 1731.88 58 1732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003366",
      stroke: "none"
    },
    d: "M628 2400L628 2392C585.958 2391.65 546.299 2357.58 529 2321C543.241 2317.7 557.055 2310.22 569 2301.97C664.952 2235.72 644.728 2060.69 523 2036.8C504.4 2033.16 485.577 2033.22 467 2037C369.233 2056.94 331.605 2175.89 377.309 2258C389.299 2279.54 407.77 2296.43 429 2308.57C437.593 2313.49 447.834 2316.2 456 2321.7C469.689 2330.92 481.276 2343.52 495 2352.97C533.062 2379.21 581 2399.99 628 2400M662 2318L750 2318L750 2310C744.364 2309.29 738.451 2308.91 733 2307.23C707.014 2299.2 725.451 2269.07 732.694 2253C735.698 2246.34 738.901 2230.98 745.275 2227.03C751.395 2223.23 765.911 2226 773 2226C797.014 2226 822.076 2223.91 845.985 2226.06C854.855 2226.85 859.105 2246.85 862.15 2254C869.326 2270.85 887.124 2301.99 859 2308.33C855.061 2309.22 851.03 2309.83 847 2310L847 2318L957 2318L957 2310C926.815 2306.17 917.567 2282.16 906.719 2257C884.834 2206.24 864.604 2154.76 842.719 2104C834.852 2085.75 827.587 2067.25 819.719 2049C817.449 2043.73 815.231 2032.11 807.213 2034.32C800.61 2036.15 795.703 2056.05 793.15 2062C780.992 2090.33 768.931 2118.7 756.719 2147C745.369 2173.31 734.15 2199.67 722.85 2226C712.848 2249.3 704.75 2277.15 688.532 2297C680.737 2306.54 662.045 2305.37 662 2318M978 2318L1066 2318L1066 2310C1061.34 2309.63 1056.58 2308.98 1052 2307.99C1022.53 2301.59 1039.97 2272.84 1047.58 2255C1050.78 2247.5 1053.99 2232.81 1060.39 2227.6C1065.72 2223.27 1080.4 2226 1087 2226C1111.59 2226 1136.44 2224.94 1161 2226.02C1170.72 2226.45 1174.21 2245.35 1177.42 2253C1184.39 2269.6 1203.38 2301.93 1175 2308.33C1171.06 2309.22 1167.03 2309.83 1163 2310L1163 2318L1273 2318L1273 2310C1243.48 2307.65 1233.64 2283.08 1223.28 2259C1201.16 2207.58 1180.24 2155.62 1158.58 2104L1135.58 2049C1133.41 2043.84 1130.93 2032.19 1123.21 2034.32C1116.46 2036.19 1111.57 2055.95 1109 2062C1097.08 2090.03 1084.92 2117.97 1073 2146C1061.64 2172.71 1049.97 2199.3 1038.58 2226C1028.6 2249.39 1020.33 2276.91 1004.33 2297C996.623 2306.67 978.045 2305.32 978 2318M201 2040L201 2049C213.524 2049 230.949 2049.51 237.03 2063C244.524 2079.62 240 2105.15 240 2123L240 2240C240 2257.22 243.625 2279.76 236.867 2296C230.989 2310.12 213.762 2310 201 2310L201 2318L320 2318L320 2310C307.222 2310 289.218 2309.86 282.97 2296C275.512 2279.46 280 2253.77 280 2236L280 2119C280 2101.84 276.37 2079.05 283.529 2063C289.966 2048.57 306.665 2049 320 2049C319.952 2035.28 302.36 2040 292 2040L201 2040z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M483 2051.43C446.432 2056.4 423.157 2083.67 413.291 2118C400.772 2161.57 401.342 2217.5 420.706 2259C432.324 2283.9 451.777 2304.61 480 2308.87C489.482 2310.3 498.512 2310.09 508 2308.84C540.506 2304.56 562.986 2278.58 573.305 2249C577.706 2236.38 579.846 2223.24 581.169 2210C586.835 2153.34 577.445 2063.78 508 2052.08C499.91 2050.72 491.158 2050.31 483 2051.43M797 2101L751 2210L844 2210C834.916 2183.15 822.093 2157.25 811.397 2131C808.095 2122.9 804.361 2105.86 797 2101M1113 2101C1098.97 2137.17 1077.23 2172.6 1067 2210L1160 2210L1115 2101L1113 2101z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIqaa);
export default __webpack_public_path__ + "static/media/iqaa.34f65605b4c56f0c0477021e2af0149a.svg";
export { ForwardRef as ReactComponent };